import { modelUtils } from '@pelicargo/utils';

import { trpc } from '../../config/trpc';

/**
 * The tenant's runtime theme overrides, or `undefined` until the query settles.
 *
 * Read straight from react-query rather than through a context provider, deliberately. A provider
 * would have to sit above `<Router/>`, so every consumer in the tree would reconcile when the theme
 * landed. react-query dedupes this call, so one request is shared and **only the components that
 * actually ask for theme values re-render**.
 *
 * Styling does not come through here at all - it reaches the DOM as CSS custom properties written
 * by `utils/applyThemeVars.ts`, which needs no React work. This hook only serves the values that
 * cannot ride a CSS variable: copy, asset slots and logo dimensions.
 */
export const useCustomerTheme = (): modelUtils.customerTheme.CustomerTheme | undefined => {
  // The theme changes only when a staff member saves one, so there is no value in revalidating it
  // on every window focus.
  const { data } = trpc.getCustomerTheme.useQuery(undefined, { staleTime: 5 * 60 * 1000 });

  return data;
};
